import { createApi } from "@reduxjs/toolkit/query/react";
import { getLoggerBaseQuery } from "../common.js";
import { LIST_TAG } from "../utils.js";
import { vnextAnalysisApiBaseQuery, TAGS } from "./common.js";
const vnextExpAnalysisApi = createApi({
  reducerPath: "exp_vnext_analysis_rtkquery",
  baseQuery: getLoggerBaseQuery(vnextAnalysisApiBaseQuery),
  endpoints: () => ({}),
  tagTypes: [LIST_TAG, ...Object.values(TAGS)]
});
export {
  vnextExpAnalysisApi
};
//# sourceMappingURL=api.js.map
